import { render, staticRenderFns } from "./AsyncList.vue?vue&type=template&id=10ca3666&scoped=true"
import script from "./AsyncList.vue?vue&type=script&lang=js"
export * from "./AsyncList.vue?vue&type=script&lang=js"
import style0 from "./AsyncList.vue?vue&type=style&index=0&id=10ca3666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca3666",
  null
  
)

export default component.exports